<template>  
      <div
        style="height:100%;width:100%;color:#052F66;background-color:rgb(245,245,220,0.90)"
      >
        <v-expansion-panels 
          accordion
            style="background-color:rgb(245,245,220,0.90)"
          >
          <v-expansion-panel
            style="background-color:rgb(245,245,220,0.90)"
          >
            <v-expansion-panel-header>My Account</v-expansion-panel-header>
            <v-expansion-panel-content>          
              <v-list
                dense
                nav
                style="background-color:transparent"
              >
                <v-list-item
                  v-if="!user.loggedIn"
                  link
                  @click="redirect('login')"
                >
                  <v-list-item-icon>
                    <v-icon >mdi-logout</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Sign in</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-else
                  link
                  @click="redirect('login')"
                >
                  <v-list-item-icon>
                    <v-icon >mdi-login</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Sign out</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="!user.loggedIn"
                  link
                  @click="redirect('register')"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account-check</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Register</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  @click="redirect('dashboard')"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-collage</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>My Dashboard</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel style="background-color:rgb(245,245,220,0.90)">
          <v-expansion-panel-header>Products</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list
              dense
              nav      
              style="background-color:transparent;color:#052F66"  
            >
              <v-list-item
                link
                @click="goToProduct('1')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-airplane</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Overseas Travel</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                link
                @click="goToProduct('4')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-bus</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Muende Bwino</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                link
                @click="goToProduct('2')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-car</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Motor Insurance</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!--<v-list-item
                link
                @click="goToProduct('3')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-car</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Motor Third Party</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                link
                @click="redirect('products/9')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-laptop</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Gadget Insurance</v-list-item-title>
                </v-list-item-content>
              </v-list-item>-->
              <v-list-item
                link
                @click="goToProduct('7')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-home-city</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>House Insurance</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel style="background-color:rgb(245,245,220,0.90)">
          <v-expansion-panel-header>Services</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list
              dense
              nav      
              style="background-color:transparent;color:#052F66"    
            >
              <v-list-item
                link
                @click="openDrawer"
              >
                <v-list-item-icon>
                  <v-icon>mdi-receipt</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Get a Quote</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                link
                @click="openBottomSheet(3)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-send</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Intimate a Claim</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                link
                @click="openBottomSheet(4)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-comment-alert</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Submit a Complaint</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                link
                @click="openBottomSheet(5)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-help-circle-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content
                  
                >
                  <v-list-item-title>Help</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!--<v-list-item
                link
                @click="openBottomSheet(5)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-help-circle-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Help</v-list-item-title>
                </v-list-item-content>
              </v-list-item>-->
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel style="background-color:rgb(245,245,220,0.90)">
          <v-expansion-panel-header>Miscellaneous</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list
              dense
              nav     
              style="background-color:transparent;color:#052F66"    
            >
              <v-list-item
                link
                @click="redirect('mobile_app')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-cellphone-iphone</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Download the App</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!--<v-list-item
                link
                @click="redirect('salvages')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-gavel</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Bid for Salvages</v-list-item-title>
                </v-list-item-content>
              </v-list-item>-->
              <v-list-item
                link
                @click="redirect('financials')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-download</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>View Financials</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                link
                @click="redirect('terms')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-scale-balance</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Terms of Use</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>  
    </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'IndividualMenu',
    components: {
  
    },
    data() {
      return {
        
      }
    },
    methods: {
      redirect(path){        
        this.$router.push(path);      
      },
      goToProduct(index){   
        var path; 
        console.log(this.$route);
        if (this.$route.name == 'product_details'){
          path = index;
        }else{
          path = 'products/' + index;
        }  
        this.$router.push(path);      
      },
      openDrawer(){
        this.components.nav_drawer.product_index=0;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;
        
      },
      openBottomSheet(index){
        if (index == 3 && this.user.loggedIn == false){
          this.$router.push('login');
        }else{
          this.components.bottom_sheet.option_index=index;
          this.components.bottom_sheet.is_open=true;
        }
      }
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    }    
  }
</script>

